<template>
  <p class="property_detail_summary" v-html="propertySummary"></p>
</template>

<script>
export default {
  name: "RecordPropertyDetailSummary",
  props: {
    property: {
      type: Object,
      required: true
    },
  },
  computed: {
    propertySummary() {
      const bedrooms = this.property.bedrooms ? this.property.bedrooms : '--';
      const baths = this.property.bathrooms ? this.property.bathrooms : '--';
      const year = this.property.year_built ? this.property.year_built : '--';
      const sqft = this.property.house_size ? this.property.house_size : '--';
      const lotSize = this.property.lot_size ? this.property.lot_size : '--';

      return bedrooms + ' bedrooms | ' + baths + ' baths | built in ' + year + '<br>' + sqft + ' sq ft | ' + lotSize + ' lot size';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.property_detail_summary {
  font-size: 0.875rem;
  line-height: 1.7;
}
</style>
